"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var css_grid_1 = require("../css-grid/css-grid");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var page_list_scss_1 = tslib_1.__importDefault(require("./page-list.scss"));
var withStyles_1 = require("../../../common/utils/withStyles");
var PageList = /** @class */ (function (_super) {
    tslib_1.__extends(PageList, _super);
    function PageList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderPage = function (items, pageNumber) {
            var _a;
            var _b = _this.props, isRTL = _b.isRTL, numberOfRows = _b.numberOfRows, numberOfColumns = _b.numberOfColumns, gridMinWidth = _b.gridMinWidth, styleId = _b.styleId, gridId = _b.gridId;
            var canUseCssGrid = numberOfRows && numberOfColumns && gridMinWidth && styleId;
            var pageStyles = classnames_1.default((_a = {},
                _a[page_list_scss_1.default.page] = !canUseCssGrid,
                _a[page_list_scss_1.default.rtl] = isRTL,
                _a[page_list_scss_1.default.ltr] = !isRTL,
                _a));
            var pageItems = _this.renderPageItems(items, pageNumber);
            return (react_1.default.createElement("div", { key: pageNumber, "data-hook": "page-list-page", className: pageStyles, style: {
                    minWidth: _this.props.pageWidth || '100vw',
                } }, pageItems && canUseCssGrid ? (react_1.default.createElement(css_grid_1.CSSGrid, { gridId: gridId, styleId: styleId, rows: numberOfRows, cols: numberOfColumns, style: { minWidth: gridMinWidth } }, pageItems)) : (pageItems)));
        };
        return _this;
    }
    PageList.prototype.shouldRenderPage = function (pageNumber) {
        var _a = this.props, currentPageNumber = _a.currentPageNumber, preRenderedCount = _a.preRenderedCount;
        return Math.abs(currentPageNumber - pageNumber) <= preRenderedCount;
    };
    PageList.prototype.renderPageItems = function (itemIds, pageNumber) {
        var _a = this.props, renderItem = _a.renderItem, currentPageNumber = _a.currentPageNumber;
        var isVisiblePage = pageNumber === currentPageNumber;
        return this.shouldRenderPage(pageNumber)
            ? itemIds.map(function (itemId, itemIndexAtPage) {
                return renderItem(itemId, itemIndexAtPage, isVisiblePage);
            })
            : null;
    };
    PageList.prototype.render = function () {
        return (react_1.default.createElement("div", { className: page_list_scss_1.default.container }, this.props.itemsByPageNumber.map(this.renderPage)));
    };
    PageList.propTypes = {
        currentPageNumber: prop_types_1.default.number,
        pageWidth: prop_types_1.default.number,
        itemsByPageNumber: prop_types_1.default.arrayOf(prop_types_1.default.array),
        preRenderedCount: prop_types_1.default.number,
        renderItem: prop_types_1.default.func,
        isRTL: prop_types_1.default.bool,
        styleId: prop_types_1.default.string,
        numberOfRows: prop_types_1.default.number,
        numberOfColumns: prop_types_1.default.number,
        gridMinWidth: prop_types_1.default.number,
    };
    PageList.defaultProps = {
        preRenderedCount: 1,
    };
    PageList = tslib_1.__decorate([
        withStyles_1.withStyles(page_list_scss_1.default)
    ], PageList);
    return PageList;
}(react_1.default.Component));
exports.default = PageList;
//# sourceMappingURL=page-list.js.map